<div class="chart-canvas-padding-compensator" [ngStyle]="{'top.rem': topAdjustment }">
  <ng-content></ng-content>
</div>
